<template>
  <div class="widgets-ui-kit">
    <div class="row">
      <div class="col-6"></div>
      <div class="col-6">
        <h2>Виджет избранных адресов</h2>

        <app-favorite-address> </app-favorite-address>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetsUIkit',
  components: {
    AppFavoriteAddress: () =>
      import('@/components/favorite-address/AppFavoriteAddress'),
  },
};
</script>

<style lang="scss">
// -
</style>
